<template>
  <div>
    <div class="needsBox">
        <div class="checkHistory" >
            <el-button type="primary" plain size="small" v-show="offerPriceForm.needsFormid" @click="showHistoryprice = true" >查看历史报价</el-button>
        </div>
        <el-form :model="offerPriceForm" ref="ruleForm" :rules="priceRules" label-width="120px" label-position="left" class="ruleForm" :inline-message="true">
            <el-form-item label="关联需求单" prop="needsFormid" :rules="[{ required: true, message: '请选择需求单', trigger: 'change' }]">
                <el-select v-model="offerPriceForm.needsFormid" placeholder="请选择需求单" name="demandid" @change="onChange" style="width: 100%">
                    <el-option 
                        v-for="item in columns"
                        :key="item.subject"
                        :label="item.subject" 
                        :value="item.subject"
                        class="option"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="招聘分类">
                <el-input 
                    readonly
                    disabled
                    name="jobClass"
                    placeholder="-"
                    v-model="offerPriceForm.needsFormData.jobClass"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="用工类别1">
                <el-input
                    readonly
                    disabled
                    name="jobType"
                    v-model="offerPriceForm.needsFormData.jobType"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="需求人数1">
                <el-input
                    readonly
                    disabled
                    name="demandNum"
			        v-model="offerPriceForm.needsFormData.demandNum"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="用工类别2">
                <el-input
                    readonly
                    disabled
                    name="jobType2"
			        v-model="offerPriceForm.needsFormData.jobType2"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="需求人数2">
                <el-input
                    readonly
                    disabled
                    name="demandNum2"
			        v-model="offerPriceForm.needsFormData.demandNum2"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="到岗开始时间">
                <el-input
                    readonly
                    disabled
                    name="workSartTime"
			        v-model="offerPriceForm.needsFormData.workSartTime"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="到岗结束时间">
                <el-input
                    readonly
                    disabled
                    name="workEndTime"
			        v-model="offerPriceForm.needsFormData.workEndTime"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="需求说明">
                <el-input
                    readonly
                    disabled
                    name="explain"
			        v-model="offerPriceForm.needsFormData.explain"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="就餐补贴">
                <el-input
                    readonly
                    disabled
                    name="mealAllowance"
			        v-model="offerPriceForm.needsFormData.mealAllowance"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="晚班补贴">
                <el-input
                    readonly
                    disabled
                    name="overtimeAllowance"
			        v-model="offerPriceForm.needsFormData.overtimeAllowance"
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item label="车费补贴">
                <el-input
                    readonly
                    disabled
                    name="fareAllowance"
			        v-model="offerPriceForm.needsFormData.fareAllowance"   
                    placeholder="-"
                    size="medium"
                ></el-input>
            </el-form-item>

            <el-form-item label="输送人数" required  prop="number"
                :rules="[{ required: true, message: '请填写输送人数'}]"
            ><el-input
                    v-model="offerPriceForm.number"
                    name="number"
                    type="number" 
                    placeholder="请输入输送人数"
                    size="medium"
                    :min="0"
                ></el-input>
            </el-form-item>
            <el-form-item label="单价(元/时/人)" prop="price" :rules="{ required: true, message: '请填写单价', trigger: 'blur' }">
                <el-input
                    v-model="offerPriceForm.price"
                    name="price"
                    type="number" 
                    placeholder="请输入单价"
                    size="medium"
                    :min="0"
                ></el-input>
            </el-form-item>
            <el-form-item label="承诺到岗开始时间" prop="promiseStartTime" :rules="{ required: true, message: '请选择日期' }">
                <el-date-picker
                    name="promiseStartTime"
                    v-model="offerPriceForm.promiseStartTime"
                    type="date"
                    placeholder="选择承诺到岗开始时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd 00:00:00"
                    :picker-options="pickerOptions"
                    style="width: 100%">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="承诺到岗结束时间" prop="promiseEndTime" :rules="{ required: true, message: '请选择日期' }">
                <el-date-picker
                    name="promiseEndTime"
                    v-model="offerPriceForm.promiseEndTime"
                    type="date"
                    placeholder="选择承诺到岗结束时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd 00:00:00"
                    :picker-options="pickerOptions"
                    style="width: 100%">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="备注">
                <el-input
                    v-model="offerPriceForm.remark"
                    name="remark"
                    rows="1"
                    autosize
                    label="备注"
                    type="textarea"
                    placeholder="请输入备注"
                ></el-input>
            </el-form-item>

            <div style="width: 100%; padding: 10px 0 30px;" >
                <el-button style="width: 100%; " type="primary" @click="submitForm" round :disabled="issubmitDisabled">提交报价</el-button>
            </div>
        </el-form>
    </div>

    <!-- 报价历史表 -->
    <el-drawer
        :visible.sync="showHistoryprice"
        :with-header="false"
        direction="btt"
        size="60%">
        <div class="priceHistory">
             <table border = "0px" cellspacing="0" cellpadding="0" class="table-t">
                <tr>
                    <th>招聘分类</th>
                    <th>用工类别1</th>
                    <th>需求人数1</th>
                    <th>用工类别2</th>
                    <th>需求人数2</th>
                    <th width="130px">到岗开始时间</th>
                    <th width="130px">到岗结束时间</th>
                    <th>需求说明</th>
                    <!-- <th>公司名称</th> -->
                    <th>就餐补贴</th>
                    <th>晚班补贴</th>
                    <th>车费补贴</th>

                    <th width="60px">输送人数</th>
                    <th width="60px">单价</th>
                    <th width="130px">承诺到岗开始时间</th>
                    <th width="130px">承诺到岗结束时间</th>
                    <th>备注</th>
                    <th>报价时间</th>
                </tr>
                <tr v-show="priceHistoryArr.length > 0" v-for="item in priceHistoryArr" :key="item.id">
                    <td>{{ offerPriceForm.needsFormData.jobClass }}</td>
                    <td>{{ offerPriceForm.needsFormData.jobType }}</td>
                    <td>{{ offerPriceForm.needsFormData.demandNum }}</td>
                    <td>{{ offerPriceForm.needsFormData.jobType2 }}</td>
                    <td>{{ offerPriceForm.needsFormData.demandNum2 }}</td>
                    <td>{{ offerPriceForm.needsFormData.workSartTime }}</td>
                    <td>{{ offerPriceForm.needsFormData.workEndTime }}</td>
                    <td>{{ item.explain }} </td>
                    <!-- <td>{{ item.company }}</td> -->
                    <td>{{ item.mealAllowance }} </td>
                    <td>{{ item.overtimeAllowance }} </td>
                    <td>{{ item.fareAllowance }} </td>

                    <td>{{ item.number }}</td>
                    <td>{{ item.price }}</td>
                    <td>{{ item.promiseStartTime }}</td>
                    <td>{{ item.promiseEndTime }}</td>
                    <td>{{ item.remark }}</td>
                    <td>{{ item.createTime }}</td>
                </tr>

                <tr v-show="priceHistoryArr.length == 0">
                    <td colspan="17" style="height: 30px; color: grey;">无数据</td>
                </tr>
            </table>
        </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
    data() {
        return {
            columns: [],
            showHistoryprice: false,       //历史报价 选择器
            url: {
                getprocessid: 'processInstance/query',  //查询流程号，get
                getprocessDetailByid: 'employmentDemand/queryByProcessid',  //根据processid查询需求表详情，get
                saveForm: 'quotation/saveForm',  //提交报价，post，传表单数据、authorName
                gethistoryForm: 'quotation/queryhisForm',  //查看报价历史，get，传demandid
            },
            priceHistoryArr: [],
            issubmitDisabled: false,
            offerPriceForm: {
                number: "",  //输送人数
                price: "",  //报价
                promiseStartTime: "",  //到岗时间
                promiseEndTime: "",  //到岗时间
                remark: "",  //报价备注
                needsFormid: "",       //选中的需求单名称
                needsFormData: {},  //需求详情
            },
            pickerOptions: {
                disabledDate: (time) => {
                    return this.getdisabledDate(time)
                }
            },
            priceRules: {},
            startDate: null,
            endDate: null
        }
    },
    mounted() {
        document.title = '劳动派遣报价'
        // 获取需求单 流程号
        this.$get(this.url.getprocessid).then(res => {
            this.columns = res
        })
    },
    methods: {
        getdisabledDate(time) {
            if(this.startDate) return time.getTime() < this.startDate  || time.getTime() > this.endDate
        },
        submitForm() {
            console.log('submitForm-', this.offerPriceForm)
            let priceObj = {
                demandid: this.offerPriceForm.needsFormid,
                number: this.offerPriceForm.number,
                price: this.offerPriceForm.price,
                promiseEndTime: this.offerPriceForm.promiseEndTime,
                promiseStartTime: this.offerPriceForm.promiseStartTime,
                remark: this.offerPriceForm.remark
            }
            let paramObj = {...this.offerPriceForm.needsFormData, ...priceObj }
            // console.log('obj',paramObj)

            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$post(this.url.saveForm, paramObj).then(res => {
                        if(res.code === 200) {
                            this.$toast.success('报价成功')
                            this.issubmitDisabled = true
                            // 提交成功后关闭当前页面
                            setTimeout(() => {
                                window.close()
                            }, 1100)
                        } else {
                            this.$toast.fail(res.message)
                        }
                    }).catch(err => {
                        this.$toast.fail(err)
                    })
                } else {
                    this.$toast.fail('必填项为空')
                    return false;
                }
            });
        },

        // 需求选择器 确认
        onChange(val) {
            this.offerPriceForm.needsFormid = val
            // console.log(val,'onChange', this.needsFormid, this.columns)
            // 传processid
            // this.getprocessDetailByid_API(val)
            this.columns.forEach(item => {
                if(item.subject === val) this.getprocessDetailByid_API(item.processid)
            })
            // 传subject
            this.gethistoryForm_API(val)
        },

        getprocessDetailByid_API(id) {
            this.$get(this.url.getprocessDetailByid, { processid: id }).then(needsRes => {
                this.offerPriceForm.needsFormData = needsRes[0]

                // this.offerPriceForm.needsFormData.workSartTime = needsRes[0].workSartTime.slice(0,10)
                // this.offerPriceForm.needsFormData.workEndTime = needsRes[0].workEndTime.slice(0,10)
                let minTime = needsRes[0].workSartTime.slice(0,10).split('-').join(',')
                let maxTime = needsRes[0].workEndTime.slice(0,10).split('-').join(',')

                this.startDate = new Date(minTime).getTime()
                this.endDate = new Date(maxTime).getTime()
            })
        },
        // 查看历史数据
        gethistoryForm_API(id) {
            this.$get(this.url.gethistoryForm, { demandid: id }).then(res => {
                this.priceHistoryArr = res
            })
        }
    }
}
</script>

<style lang="less" scoped>
.ruleForm {
    padding: 0 10px;
}
.option {
    height: 40px;
    font-size: 16px;
    font-weight: 550;
}
/deep/ .el-form-item__label {
    font-size: 12px;
}
/deep/ .el-form-item {
    margin-bottom: 10px;
}
.checkHistory {
    height: 38px;
    padding: 4px 16px 0;
    text-align: right;
}
.priceHistory  {
    margin-top: 50px;
    padding: 0 16px;
    height: 500px;
    overflow: auto;
    .table-t {
        width: 100%;
        // border-color: #dad8d8;
        margin-bottom: 10px;
        overflow: scroll;
    }
    th {
        min-width: 50px;
        background: #e8eaec;
        height: 40px;
        color: #606266;
        text-align: center;
        font-size: 14px;
    }
    td {
        padding:4px;
        text-align: center;
        border: 0.5px solid #eeeeee;
        color: #1D2129;
        font-size: 12px;
    }
}
</style>